module.exports = __webpack_public_path__ + "static/media/facebookInTouch.f5ceceb8.svg";